import "./App.css";
export default function App() {
  return (
    <div className="App">
      <div className="github-link">
        <a
          href="https://github.com/HipLiv/Project"
          target="_blank"
          rel="noreferrer"
        >
          {" "}
          Open-Source Code
        </a>
        <p> by Olivia</p>
      </div>
      <script src="src/script.js"></script>
    </div>
  );
}
